import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import SelectDropdown from "../components-react/SelectDropdown";
import {
  convertThenFormat,
  convertToYYYYMMDD,
  currentMonthCurrentDate,
} from "../common-data/Converts";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { fetchGymData } from "../../data/APIs";
import { add_df_payment, add_pt_df_payment } from "../../data/ApiEndpoints";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { selectGymData } from "../../redux/reducers/gymDataSlice";
import { createFetchPlans } from "../../redux/reducers/postApiSlice";
import {
  df_payment_modes,
  partialPaymentModes,
  planTypes,
} from "../common-data/DropdowData";
import {
  fetchAllAddonsByGymData,
  fetchAllAddonSessionsData,
  fetchAllAddonSlotsData,
  fetchAllTrainersByExpLvlData,
  fetchAllTrainersSlotsData,
} from "../../redux/reducers/apiSlice";
import { validateForm } from "./dp-data/DPData";
import {
  fetchIndividualTypeData,
  fetchSourceNameData,
} from "../../redux/reducers/dropdownApiSlice";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

const DPForm = ({ closeModal, callFunction, userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    allAddonsByGymData,
    allAddonSessions,
    allTrainerByExpLvlData,
    loading,
    error,
    trainerSlotDetails,
  } = useSelector((state) => state.api);
  const { sourceNames, individualData } = useSelector(
    (state) => state.dropdown
  );
  const gymData = useSelector(selectGymData);

  const isAdmin = userInfoData?.account_type === "admin";
  const isTrainer = userInfoData?.account_type === "trainer";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [regularPlans, setRegularPlans] = useState([]);
  const [planPrices, setPlanPrices] = useState([]);
  const [allAddons, setAllAddons] = useState(null);
  const [allSessions, setAllSessions] = useState([]);
  const initialTrainerSlotsData = {
    trainersDropdownData: [],
    trainerSlotsInfoData: [],
  };
  const [allTrainerSlotData, setAllTrainerSlotData] = useState(
    initialTrainerSlotsData
  );

  const iniFormValues = {
    selectedGym:
      !isAdmin && userInfoData?.gym_name && userInfoData?.gym_id
        ? {
            label: userInfoData.gym_name,
            value: userInfoData.gym_id,
          }
        : rowData?.gym_name && rowData?.gym_id
        ? {
            label: rowData.gym_name,
            value: rowData.gym_id,
          }
        : "",
    memberName: rowData?.name || "",
    memberMobile: rowData?.mobile || "",
    memberEmail: rowData?.email || "",
    memberGender: rowData?.gender || "",
    memberDOB: rowData?.dob ? convertToYYYYMMDD(rowData.dob) : "",

    selectedPlanType: "",
    selectedPlan: "",
    planPrice: "",
    extendableDays: "",

    selectedPlanIndex: "",
    selectedPrice: "",

    selectedSession: "",
    selectedSlotDate: "",
    selectedTrainer:
      isTrainer &&
      userInfoData?.name &&
      (userInfoData?.uid || userInfoData?.user_id)
        ? {
            label: userInfoData.name,
            value: userInfoData?.uid || userInfoData?.user_id,
          }
        : "",
    selectedSlotIndex: "",
    selectedSlotStartTime: "",
    selectedSlotEndTime: "",
    selectedSlot: "",

    selectedSubsStartDate: "",
    selectedSubsEndDate: "",

    selectedPaymentMode: "",
    cashAmount: "",
    onlineAmount: "",
    selectedFirstPartialPaymentMode: "",

    selSourceName: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const formRef = useRef({});
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [installments, setInstallments] = useState({
    firInsAmount: "",
    secInsAmount: "",
    thiInsAmount: "",
    firInsDate: "",
    secInsDate: "",
    thiInsDate: "",
  });

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setIsSubmit(false);

    // Handle installment fields
    if (
      [
        "firInsAmount",
        "secInsAmount",
        "thiInsAmount",
        "firInsDate",
        "secInsDate",
        "thiInsDate",
      ].includes(name)
    ) {
      setInstallments((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    // Handle dual payment logic
    const isDual = formValues.selectedPaymentMode?.value === "dual";
    const selectedAmount = Number(formValues.planPrice || 0);

    if (isDual && selectedAmount && name === "cashAmount") {
      const onlineAmount =
        selectedAmount > value ? selectedAmount - Number(value || 0) : 0;

      setFormValues((prevs) => ({
        ...prevs,
        onlineAmount: onlineAmount,
        [name]: value,
      }));
    } else if (isDual && selectedAmount && name === "onlineAmount") {
      const cashAmount =
        selectedAmount > value ? selectedAmount - Number(value || 0) : 0;

      setFormValues((prevs) => ({
        ...prevs,
        cashAmount: cashAmount,
        [name]: value,
      }));
    } else if (name === "selectedSubsStartDate") {
      const isPT = formValues.selectedPlanType?.value === "addon_pt";
      const planDuration = isPT
        ? Number(formValues.selectedSession?.info?.duration || 0)
        : Number(formValues.selectedPlan?.info?.duration || 0);

      const subsEndDate =
        value && planDuration
          ? moment(value, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .add(planDuration, "days")
              .format("YYYY-MM-DD")
          : "";

      setFormValues((prevs) => ({
        ...prevs,
        selectedSubsEndDate: subsEndDate,
        [name]: value,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    if (name === "selectedGym") {
      setFormValues({
        ...formValues,
        selectedPlan: "",
        selectedSession: "",
        selectedTrainer:
          isTrainer &&
          userInfoData?.name &&
          (userInfoData?.uid || userInfoData?.user_id)
            ? {
                label: userInfoData.name,
                value: userInfoData?.uid || userInfoData?.user_id,
              }
            : "",
        selectedSlot: "",
        [name]: value,
      });
      setRegularPlans([]);
      setPlanPrices([]);
      setAllAddons(null);
      setAllSessions([]);
      setAllTrainerSlotData(initialTrainerSlotsData);
    } else if (formValues.selectedSubsStartDate && name === "selectedPlan") {
      const planDuration = Number(value?.info?.duration || 0);
      const startDate = formValues.selectedSubsStartDate;
      const subsEndDate =
        startDate && planDuration
          ? moment(startDate, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .add(planDuration, "days")
              .format("YYYY-MM-DD")
          : "";

      setFormValues({
        ...formValues,
        selectedPlanIndex: "",
        selectedPrice: "",
        selectedExtendedDays: "",
        finalBaseAmount: value?.info?.base_price || 0,
        selectedPaymentMode: "",
        selectedFirstPartialPaymentMode: "",
        selectedSubsEndDate: subsEndDate,
        [name]: value,
      });
    } else if (name === "selectedPlan") {
      setFormValues({
        ...formValues,
        selectedPlanIndex: "",
        selectedSlotDate: "",
        selectedSlot: "",
        selectedSession: "",
        selectedPrice: "",
        selectedPaymentMode: "",
        [name]: value,
      });
    } else if (formValues.selectedSubsStartDate && name === "selectedSession") {
      const sessionDuration = Number(value?.info?.duration || 0);
      const startDate = formValues.selectedSubsStartDate;

      const subsEndDate =
        startDate && sessionDuration
          ? moment(startDate, "YYYY-MM-DD")
              .tz("Asia/Kolkata")
              .add(sessionDuration, "days")
              .format("YYYY-MM-DD")
          : "";

      setFormValues({
        ...formValues,
        selectedSubsEndDate: subsEndDate,
        selectedTrainer: isTrainer ? formValues.selectedTrainer : "",
        [name]: value,
      });
    } else if (name === "selectedSession") {
      setFormValues({
        ...formValues,
        selectedTrainer: isTrainer ? formValues.selectedTrainer : "",
        [name]: value,
      });
    } else if (name === "selectedPlanType") {
      setFormValues({
        ...formValues,
        selectedPlanIndex: "",
        selectedPlan: "",
        selectedSlotDate: "",
        selectedSlot: "",
        selectedSession: "",
        selectedPrice: "",
        [name]: value,
      });
    } else if (name === "selectedTrainer") {
      setFormValues({
        ...formValues,
        selectedSlotIndex: "",
        [name]: value,
      });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleSelectSlot = (index, start, end, slotId) => {
    if (index === formValues.selectedSlotIndex) {
      setFormValues((prevs) => ({
        ...prevs,
        selectedSlotIndex: "",
        selectedSlotStartTime: "",
        selectedSlotEndTime: "",
        selectedSlot: "",
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        selectedSlotIndex: index,
        selectedSlotStartTime: start,
        selectedSlotEndTime: end,
        selectedSlot: slotId,
      }));
    }
  };

  const handleCreateFetchPlans = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(createFetchPlans({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data?.length > 0) {
        const planData = result.payload.data || [];

        const allPlansDropdownData = planData.map((plan) => {
          return {
            label: `${plan.plan_name}/${plan.duration}Days`,
            value: plan.plan_uid,
            is_couple: plan?.is_couple,
            info: plan,
          };
        });

        setRegularPlans(allPlansDropdownData);
      } else {
        const errorMessage = result?.error?.message;
        console.log("errorMessage=> ", errorMessage);
      }
    } catch (error) {
      console.log("handleCreateFetchPlans ERROR => ", error);
    }
  };

  const handleFetchGymAddons = (gymID) => {
    dispatch(
      fetchAllAddonsByGymData({
        gymId: gymID,
        isPT: 1,
        token: userInfoData?.token,
      })
    );
  };

  const handleFetchSessions = (addonID) => {
    dispatch(
      fetchAllAddonSessionsData({
        addonId: addonID,
        token: userInfoData?.token,
      })
    );
  };

  const handleFetchSlots = (addonID, slotDate) => {
    dispatch(
      fetchAllAddonSlotsData({
        addonId: addonID,
        slotDate: slotDate,
        token: userInfoData?.token,
      })
    );
  };

  const handleFetchTrainers = (qps) => {
    dispatch(
      fetchAllTrainersByExpLvlData({
        queryParameters: qps,
        token: userInfoData?.token,
      })
    );
  };

  const handleFetchTrainerSlot = (trainerID) => {
    dispatch(
      fetchAllTrainersSlotsData({
        trainerSlot: trainerID,
        token: userInfoData?.token,
      })
    );
  };

  function getAllAdmins(gymId) {
    dispatch(
      fetchIndividualTypeData({
        token: userInfoData?.token,
        qps: `account_type=receptionist,trainer&gym_id=${gymId}`,
        pageNo: 1,
        limit: 100,
      })
    );
  }

  function getSourceName() {
    const filter = {
      page: 1,
      limit: 200,
    };

    dispatch(
      fetchSourceNameData({
        filters: filter,
        token: userInfoData?.token,
      })
    );
  }

  const handleSubmitForm = async (payload, endpoint) => {
    const method = "POST";
    // const endpoint = add_df_payment;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const errors = validateForm(formValues, installments);
    setFormErrors(errors);
    setIsSubmit(true);

    if (formRef.current) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );

      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const assignRef = (fieldName) => (el) => {
    if (!formRef.current) {
      formRef.current = {};
    }

    if (el) {
      formRef.current[fieldName] = el;
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      selectedGym:
        !isAdmin && userInfoData?.gym_name && userInfoData?.gym_id
          ? {
              label: userInfoData.gym_name,
              value: userInfoData.gym_id,
            }
          : rowData?.gym_name && rowData?.gym_id
          ? {
              label: rowData.gym_name,
              value: rowData.gym_id,
            }
          : "",
      memberName: rowData?.name || "",
      memberMobile: rowData?.mobile || "",
      memberEmail: rowData?.email || "",
    }));
  }, [userInfoData.gym_id]);

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token));
    getSourceName();
  }, []);

  useEffect(() => {
    if (formValues.selectedGym?.value) {
      if (formValues.selectedPlanType?.value === "regular") {
        handleCreateFetchPlans(
          {
            gym_id: formValues.selectedGym.value,
            couple_included: 0,
          },
          userInfoData?.token
        );
      } else if (formValues.selectedPlanType?.value === "addon_pt") {
        handleFetchGymAddons(formValues.selectedGym.value);
      }
    }
  }, [formValues.selectedGym, formValues.selectedPlanType]);

  useEffect(() => {
    if (allAddons?.value) {
      handleFetchSessions(allAddons.value);

      if (formValues.selectedSlotDate) {
        const slotDate = moment(formValues.selectedSlotDate)
          .tz("Asia/Kolkata")
          .format("DD-MM-YYYY");

        handleFetchSlots(allAddons.value, slotDate);
      }
    }
  }, [allAddons, formValues.selectedSlotDate]);

  useEffect(() => {
    if (formValues.selectedGym?.value && formValues.selectedSession?.value) {
      const selectedGymQueryParam =
        !isAdmin && !isManagerRole
          ? `&gym_id=${
              userInfoData?.gym_id || userInfoData?.user_id || userInfoData?.uid
            }`
          : formValues?.selectedGym?.value
          ? `&gym_id=${formValues.selectedGym.value}`
          : "";
      const expLvlQueryParam = `&trainer_exp_lvl=${
        formValues.selectedSession?.info?.trainer_exp_lvl || ""
      }`;
      const queryParameters = `${selectedGymQueryParam}${expLvlQueryParam}`;

      handleFetchTrainers(queryParameters);
    }
  }, [formValues.selectedGym, formValues.selectedSession]);

  useEffect(() => {
    if (formValues.selectedTrainer?.value) {
      handleFetchTrainerSlot(formValues.selectedTrainer.value);
    }
  }, [formValues.selectedTrainer]);

  useEffect(() => {
    getAllAdmins(formValues.selectedGym?.value || "");
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (!loading && !error && trainerSlotDetails?.data) {
      const selectedTrainerData = trainerSlotDetails.data?.slot_details || null;

      setAllTrainerSlotData({
        ...allTrainerSlotData,
        trainerSlotsInfoData: selectedTrainerData ? selectedTrainerData : [],
      });
    } else {
      setAllTrainerSlotData({
        ...allTrainerSlotData,
        trainerSlotsInfoData: [],
      });
    }
  }, [loading, error, trainerSlotDetails]);

  useEffect(() => {
    if (allTrainerByExpLvlData?.status && allTrainerByExpLvlData?.data) {
      const trainers = allTrainerByExpLvlData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainerSlotData((prevAllTrainerSlotData) => ({
        ...prevAllTrainerSlotData,
        trainersDropdownData: trainers,
      }));
    } else {
      setAllTrainerSlotData((prevAllTrainerSlotData) => ({
        ...prevAllTrainerSlotData,
        trainersDropdownData: [],
      }));
    }
  }, [allTrainerByExpLvlData]);

  useEffect(() => {
    if (allAddonsByGymData?.status && allAddonsByGymData?.data?.length > 0) {
      const allPTs = allAddonsByGymData.data
        .filter((addon) => addon?.is_pt === "1")
        .map((addon) => ({
          label: `${addon.name} / PT`,
          value: addon?.uid,
          info: addon,
        }));

      setAllAddons(allPTs[0]);
    } else {
      setAllAddons(null);
    }
  }, [allAddonsByGymData]);

  useEffect(() => {
    if (allAddonSessions?.status && allAddonSessions?.data?.length > 0) {
      const allAddonsSessionsDropdownDataFind = allAddonSessions.data.map(
        (addon) => {
          return {
            label:
              `${addon?.n_session} Sessions for ${addon?.duration} Day(s)` ||
              "",
            value: addon?.uid || "",
            info: addon,
          };
        }
      );

      setAllSessions(allAddonsSessionsDropdownDataFind);
    } else {
      setAllSessions([]);
    }
  }, [allAddonSessions]);

  useEffect(() => {
    if (
      (formValues.selectedPlanType?.value === "regular" &&
        formValues.selectedPlan?.info) ||
      (formValues.selectedPlanType?.value === "addon_pt" &&
        formValues.selectedSession?.info)
    ) {
      const priceDetails =
        formValues.selectedPlanType?.value === "regular"
          ? formValues.selectedPlan?.info?.price_details || []
          : formValues.selectedSession?.info?.price_details || [];
      if (priceDetails) {
        setPlanPrices(priceDetails);
      } else {
        setPlanPrices([]);
      }
    }
  }, [
    formValues.selectedPlanType,
    formValues.selectedPlan,
    formValues.selectedSession,
  ]);

  useEffect(() => {
    const isPartial = formValues.selectedPaymentMode?.value === "partial";
    const isRegular = formValues.selectedPlanType?.value === "regular";

    if (
      isPartial &&
      isRegular &&
      formValues.selectedPlan?.info &&
      formValues.planPrice &&
      formValues.selectedSubsStartDate
    ) {
      const planInfo = formValues.selectedPlan?.info || {};
      const selectedAmount = Number(formValues.planPrice || 0);

      let firstInstallmentDate = "",
        secondInstallmentDate = "",
        thirdInstallmentDate = "";

      const firstEmiPercentage = Number(planInfo.first_emi_percentage) || 0;
      const secondEmiPercentage = Number(planInfo.second_emi_percentage) || 0;
      const thirdEmiPercentage = Number(planInfo.third_emi_percentage) || 0;

      const firstInstallmentAmount =
        (selectedAmount * firstEmiPercentage) / 100;
      const secondInstallmentAmount =
        (selectedAmount * secondEmiPercentage) / 100;
      const thirdInstallmentAmount =
        (selectedAmount * thirdEmiPercentage) / 100;

      const { second_emi_duration, third_emi_duration } = planInfo;

      firstInstallmentDate = moment(
        formValues.selectedSubsStartDate,
        "YYYY-MM-DD"
      )
        .tz("Asia/Kolkata")
        .add(1, "days")
        .format("YYYY-MM-DD");
      secondInstallmentDate = moment(firstInstallmentDate, "YYYY-MM-DD")
        .tz("Asia/Kolkata")
        .add(second_emi_duration, "days")
        .format("YYYY-MM-DD");
      thirdInstallmentDate = moment(secondInstallmentDate, "YYYY-MM-DD")
        .tz("Asia/Kolkata")
        .add(third_emi_duration, "days")
        .format("YYYY-MM-DD");

      setInstallments({
        firInsAmount: firstInstallmentAmount,
        secInsAmount: secondInstallmentAmount,
        thiInsAmount: thirdInstallmentAmount,
        firInsDate: firstInstallmentDate,
        secInsDate: secondInstallmentDate,
        thiInsDate: thirdInstallmentDate,
      });
    } else {
      setInstallments({
        firInsAmount: "",
        secInsAmount: "",
        thiInsAmount: "",
        firInsDate: "",
        secInsDate: "",
        thiInsDate: "",
      });
    }
  }, [
    formValues.selectedPaymentMode,
    formValues.selectedPlanType,
    formValues.selectedPlan,
    formValues.planPrice,
    formValues.selectedSubsStartDate,
  ]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const isPT = formValues.selectedPlanType?.value === "addon_pt";
      const isPartial = formValues.selectedPaymentMode?.value === "partial";
      const isDual = formValues.selectedPaymentMode?.value === "dual";

      const userData = {
        created_by: userInfoData?.uid || userInfoData?.user_id || "",
        user_id: rowData?.uid || rowData?.user_id || "",
        gym_id: formValues.selectedGym?.value || "",
        plan_id: formValues.selectedPlan?.value || "",
        plan_price: formValues.planPrice || "",
        extend_days: formValues.extendableDays || "",
        start_date: formValues?.selectedSubsStartDate || "",
        expire_date: formValues?.selectedSubsEndDate || "",
        requested_by: formValues.selectedRequestedBy?.value || "",
        lead_source: formValues.selSourceName?.value || "",
        type: "custom",

        payment_mode: isDual
          ? "cash/online"
          : formValues.selectedPaymentMode?.value || "",
        cash_amount: isDual ? formValues.cashAmount || "" : "",
        online_amount: isDual ? formValues.onlineAmount || "" : "",
        first_payment_mode: isPartial
          ? formValues.selectedFirstPartialPaymentMode?.value || ""
          : "",
        partial_payment_details: isPartial
          ? [
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: installments.firInsAmount || "",
                date: installments.firInsDate || "",
                payment_mode:
                  formValues.selectedFirstPartialPaymentMode?.value || "",
                status: "completed",
                subscription_id: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: installments.secInsAmount || "",
                date: installments.secInsDate || "",
                payment_mode: "",
                subscription_id: "",
                status: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
            ]
          : [],
      };

      const userDataPT = {
        created_by: userInfoData?.uid ?? userInfoData?.user_id ?? "",
        plan_id: allAddons?.value ?? "",
        plan_price: formValues.planPrice ?? "",
        session_id: formValues.selectedSession?.value ?? "",
        trainer_id: formValues.selectedTrainer?.value ?? "",
        start_time: formValues?.selectedSlotStartTime ?? "",
        end_time: formValues?.selectedSlotEndTime ?? "",
        user_id: rowData?.uid ?? rowData?.user_id ?? "",
        gym_id: formValues.selectedGym?.value ?? "",
        start_date: formValues?.selectedSubsStartDate ?? "",
        expire_date: formValues?.selectedSubsEndDate ?? "",
        lead_source: formValues.selSourceName?.value ?? "",
        requested_by: formValues.selectedRequestedBy?.value ?? "",

        payment_mode: isDual
          ? "cash/online"
          : formValues.selectedPaymentMode?.value || "",
        cash_amount: isDual ? formValues.cashAmount || "" : "",
        online_amount: isDual ? formValues.onlineAmount || "" : "",
        first_payment_mode: isPartial
          ? formValues.selectedFirstPartialPaymentMode?.value || ""
          : "",
        partial_payment_details: isPartial
          ? [
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: installments.firInsAmount || "",
                date: installments.firInsDate || "",
                payment_mode:
                  formValues.selectedFirstPartialPaymentMode?.value || "",
                status: "completed",
                subscription_id: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
              {
                user_id: rowData?.uid || rowData?.user_id || "",
                amount: installments.secInsAmount || "",
                date: installments.secInsDate || "",
                payment_mode: "",
                subscription_id: "",
                status: "",
                date_added: "",
                order_id: "",
                payment_id: "",
              },
            ]
          : [],
      };

      const handleConfirm = async () => {
        handleSubmitForm(
          isPT ? userDataPT : userData,
          isPT ? add_pt_df_payment : add_df_payment
        );
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log(userInfoData, " <==> ", formValues);

  return (
    <div className="form-container open-form-page-container dp-form mb150">
      <CommonHeadingNBtns
        title={`Discount Payment Link`}
        btnTxt={isAdmin ? "← Send Link" : "← Request Approval"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
        isDisabled={postPutLoading}
      />

      <form
        className="formContainer"
        style={{
          marginTop: "30px",
        }}
      >
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="memberName" className={`formInputLabel`}>
              member Name
            </label>

            <input
              type="text"
              placeholder="Name"
              className={`formInput`}
              name="memberName"
              value={formValues.memberName}
              disabled
            />

            <span className="error-label">{formErrors?.memberName || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberMobile" className={`formInputLabel`}>
              member mobile
            </label>

            <input
              type="number"
              placeholder="Mobile Number"
              className={`formInput`}
              name="memberMobile"
              value={formValues.memberMobile}
              disabled
            />

            <span className="error-label">
              {formErrors?.memberMobile || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberEmail" className={`formInputLabel`}>
              member email
            </label>

            <input
              type="email"
              placeholder="Email"
              className={`formInput`}
              name="memberEmail"
              value={formValues.memberEmail}
              disabled
            />

            <span className="error-label">{formErrors?.memberEmail || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberGender" className="formInputLabel">
              member gender
            </label>

            <input
              type="text"
              placeholder="Not Available"
              className={`formInput`}
              name="memberGender"
              value={formValues.memberGender}
              disabled
            />
          </div>

          {formValues.memberDOB && (
            <div className="formInputBox">
              <label htmlFor="memberDOB" className="formInputLabel">
                member DOB
              </label>

              <input
                type="date"
                className={`formInput ${
                  formValues.memberDOB ? "date-has-value" : ""
                }`}
                name="memberDOB"
                value={formValues.memberDOB}
                onChange={(e) =>
                  setFormValues({ ...formValues, memberDOB: e.target.value })
                }
                max={currentMonthCurrentDate}
                disabled
              />
            </div>
          )}

          <div className="formInputBox span2">
            <label htmlFor="selectedGym" className={`formInputLabel`}>
              gym name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
              ref={assignRef("selectedGym")}
            >
              <SelectDropdown
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                name="Gym"
                isDisable={
                  isAdmin || isManagerRole
                    ? false
                    : formValues.selectedGym?.value
                }
              />
            </div>

            <span className="error-label">{formErrors?.selectedGym || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPlanType" className="formInputLabel">
              Plan Type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPlanType && "formError"
              }`}
              ref={assignRef("selectedPlanType")}
            >
              <SelectDropdown
                options={planTypes}
                selectedOption={formValues.selectedPlanType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedPlanType")
                }
                name="Plan Type"
              />
            </div>

            <span className="error-label">
              {formErrors?.selectedPlanType || ""}
            </span>
          </div>

          {formValues.selectedPlanType?.value === "regular" ? (
            <div className="formInputBox">
              <label htmlFor="selectedPlan" className="formInputLabel">
                regular Plan <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedPlan && "formError"
                }`}
                ref={assignRef("selectedPlan")}
              >
                <SelectDropdown
                  options={regularPlans}
                  selectedOption={formValues.selectedPlan}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown(selectedValue, "selectedPlan")
                  }
                  name="Plan"
                />
              </div>

              <span className="error-label">
                {formErrors?.selectedPlan || ""}
              </span>
            </div>
          ) : formValues.selectedPlanType?.value === "addon_pt" ? (
            <>
              <div className="formInputBox">
                <label htmlFor="selectedSlotDate" className="formInputLabel">
                  slot date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  name="selectedSlotDate"
                  ref={assignRef("selectedSlotDate")}
                  className={`formInput ${
                    formErrors.selectedSlotDate ? "formError" : ""
                  } ${formValues.selectedSlotDate ? "date-has-value" : ""}`}
                  value={formValues.selectedSlotDate}
                  onChange={onChangeInput}
                  min={currentMonthCurrentDate}
                />

                <span className="error-label">
                  {formErrors?.selectedSlotDate || ""}
                </span>
              </div>

              <div className="formInputBox" ref={assignRef("selectedSession")}>
                <label htmlFor="selectedSession" className="formInputLabel">
                  PT session <span className="required">*</span>
                </label>

                {!allAddons ? (
                  <span className="errorMessage m-0">No PT Addon Found!</span>
                ) : allAddons && allSessions?.length === 0 ? (
                  <span className="errorMessage m-0">No Session Found!</span>
                ) : (
                  <div
                    className={`commonWrapper ${
                      formErrors.selectedSession ? "formError" : ""
                    }`}
                  >
                    <SelectDropdown
                      options={allSessions}
                      selectedOption={formValues.selectedSession}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedSession")
                      }
                      name="selectedSession"
                    />
                  </div>
                )}

                <span className="error-label">
                  {formErrors?.selectedSession || ""}
                </span>
              </div>

              {(formValues.selectedSession?.value || isTrainer) && (
                <div className="formInputBox">
                  <label htmlFor="selectedTrainer" className="formInputLabel">
                    Trainer <span className="required">*</span>
                  </label>

                  {!isTrainer &&
                  !formValues.selectedSession?.info?.trainer_exp_lvl ? (
                    <span className="errorMessage m-0">
                      Experience Level Is NULL
                    </span>
                  ) : !isTrainer &&
                    allTrainerSlotData.trainersDropdownData?.length === 0 ? (
                    <span className="errorMessage m-0">No Trainer Found!</span>
                  ) : (
                    <div
                      className={`commonWrapper ${
                        formErrors.selectedTrainer ? "formError" : ""
                      }`}
                      ref={assignRef("selectedTrainer")}
                    >
                      <SelectDropdown
                        options={allTrainerSlotData.trainersDropdownData}
                        selectedOption={formValues.selectedTrainer}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown(selectedValue, "selectedTrainer")
                        }
                        name="selectedTrainer"
                        isDisable={
                          isTrainer && formValues.selectedTrainer?.value
                        }
                      />
                    </div>
                  )}

                  <span className="error-label">
                    {formErrors?.selectedTrainer || ""}
                  </span>
                </div>
              )}
            </>
          ) : null}

          <div className="formInputBox">
            <label htmlFor="planPrice" className="formInputLabel">
              amount <span className="required">*</span>
            </label>

            <input
              type="number"
              name="planPrice"
              ref={assignRef("planPrice")}
              placeholder="Enter Plan Price"
              className={`formInput ${formErrors.planPrice ? "formError" : ""}`}
              value={formValues.planPrice}
              onChange={onChangeInput}
              min={0}
            />

            <span className="error-label">{formErrors?.planPrice || ""}</span>
          </div>

          {formValues.selectedPlanType?.value === "regular" && (
            <div className="formInputBox">
              <label htmlFor="extendableDays" className="formInputLabel">
                Extendable Days <span className="not required">(Optional)</span>
              </label>

              <input
                type="number"
                name="extendableDays"
                ref={assignRef("extendableDays")}
                placeholder="Enter Extendable Days"
                className={`formInput ${
                  formErrors.extendableDays ? "formError" : ""
                }`}
                value={formValues.extendableDays}
                onChange={onChangeInput}
              />

              <span className="error-label">
                {formErrors?.extendableDays || ""}
              </span>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="memberMobile2" className="formInputLabel">
              Subscription start date <span className="required">*</span>
            </label>

            <input
              type="date"
              name="selectedSubsStartDate"
              ref={assignRef("selectedSubsStartDate")}
              className={`formInput ${
                formErrors.selectedSubsStartDate ? "formError" : ""
              } ${formValues.selectedSubsStartDate ? "date-has-value" : ""}`}
              value={formValues.selectedSubsStartDate}
              onChange={onChangeInput}
            />

            <span className="error-label">
              {formErrors?.selectedSubsStartDate || ""}
            </span>
          </div>

          {formValues.selectedSubsEndDate && (
            <div className="formInputBox">
              <label htmlFor="selectedSubsEndDate" className="formInputLabel">
                Subscription expire date
              </label>

              <input
                type="date"
                name="selectedSubsEndDate"
                ref={assignRef("selectedSubsEndDate")}
                className={`formInput ${
                  formErrors.selectedSubsEndDate ? "formError" : ""
                } ${formValues.selectedSubsEndDate ? "date-has-value" : ""}`}
                value={formValues.selectedSubsEndDate}
                onChange={onChangeInput}
                min={currentMonthCurrentDate}
                disabled
              />

              <span className="error-label">
                {formErrors?.selectedSubsEndDate || ""}
              </span>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="selectedRequestedBy" className="formInputLabel">
              requested by <span className="not required">(Optional)</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedRequestedBy ? "formError" : ""
              }`}
              ref={assignRef("selectedRequestedBy")}
            >
              <SelectDropdown
                options={
                  individualData && individualData?.length > 0
                    ? individualData
                    : []
                }
                selectedOption={formValues.selectedRequestedBy}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedRequestedBy")
                }
                name="requested by"
              />
            </div>

            <span className="error-label">
              {formErrors?.selectedRequestedBy || ""}
            </span>
          </div>
        </div>

        <div className="formInputsGrid fourGridSystem">
          {/* SELECT SLOT */}
          {formValues.selectedPlanType?.value === "addon_pt" && (
            <>
              <div className="flexWrapMultiBoxontainer span4">
                <div className="formInputBox" ref={assignRef("selectedSlot")}>
                  <label htmlFor="selectedSlot" className="formInputLabel">
                    trainer Slot <span className="required">*</span>
                  </label>

                  {allTrainerSlotData?.trainerSlotsInfoData?.length > 0 ? (
                    <div
                      className={`flexWrapMultiBoxontainerSub ${
                        formErrors.selectedSlot ? "formError" : ""
                      }`}
                    >
                      {allTrainerSlotData?.trainerSlotsInfoData?.map(
                        (slot, index) => (
                          <div
                            className={`wrappedBox ${
                              slot?.is_available === false ? "disabledSlot" : ""
                            } ${
                              formValues.selectedSlotIndex === index
                                ? "selected"
                                : ""
                            }`}
                            style={{
                              cursor:
                                slot?.is_available === false
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            key={index}
                            onClick={() =>
                              slot?.is_available !== false &&
                              handleSelectSlot(
                                index,
                                slot?.start_time,
                                slot?.end_time,
                                slot?.slot_id
                              )
                            }
                            disabled={slot?.is_available === false}
                          >
                            <span className="wappedValueLabel textSmol">
                              {`${moment(slot?.start_time, "HH:mm")
                                .tz("Asia/Kolkata")
                                .format("h:mm A")} - ${moment(
                                slot?.end_time,
                                "HH:mm"
                              )
                                .tz("Asia/Kolkata")
                                .format("h:mm A")}` || "-"}
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    <span className="errorMessage m-0">
                      Slots Not Available
                    </span>
                  )}

                  <span className="error-label">
                    {formErrors?.selectedSlot || ""}
                  </span>
                </div>
              </div>
            </>
          )}
          {/* ------------------- SELECT SLOT  ------------------- */}

          {(formValues.selectedPlan || formValues.selectedSession) && (
            <div className="flexWrapMultiBoxontainer span4">
              <div className="formInputBox">
                <label htmlFor="selectedPrice" className="formInputLabel">
                  current available Plan Prices
                </label>

                {planPrices?.length > 0 ? (
                  <div
                    className={`flexWrapMultiBoxontainerSub mb-rg3rem ${
                      formErrors.selectedPrice ? "formError" : ""
                    }`}
                    ref={assignRef("selectedPrice")}
                    style={{
                      border: "1px solid #c2c2c2",
                      boxShadow: "none",
                      background: "#fff",
                    }}
                  >
                    {planPrices?.map((price, index) => {
                      const extendedDaysNumber = price?.extend_days || 0;

                      return (
                        <div
                          className={`wrappedBox ${
                            formValues.selectedPlanIndex === index
                              ? "selected"
                              : ""
                          }`}
                          key={index}
                          disabled
                        >
                          <span
                            className="wappedValueLabel"
                            style={{
                              padding: "15px 20px",
                              fontSize: "18px",
                              cursor: "not-allowed",
                              background: "#854836",
                              opacity: "0.5",
                            }}
                          >
                            ₹{convertThenFormat(price?.plan_price || 0)}{" "}
                            {formValues.selectedPlanType?.value === "addon_pt"
                              ? null
                              : `(
                            ${extendedDaysNumber || 0} Days)`}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <span className="errorMessage m-0">Price Not Available</span>
                )}

                <span className="error-label">
                  {formErrors?.selectedPrice || ""}
                </span>
              </div>
            </div>
          )}

          <div className="formInputBox">
            <label htmlFor="selSourceName" className="formInputLabel">
              Source Name <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selSourceName && "formError"
              }`}
              ref={assignRef("selSourceName")}
            >
              <SelectDropdown
                options={sourceNames?.length > 0 ? sourceNames : []}
                selectedOption={formValues.selSourceName}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selSourceName")
                }
                name="Source Name"
                // preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPaymentMode" className="formInputLabel">
              Payment mode <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPaymentMode ? "formError" : ""
              }`}
              ref={assignRef("selectedPaymentMode")}
            >
              <SelectDropdown
                options={df_payment_modes}
                selectedOption={formValues.selectedPaymentMode}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedPaymentMode")
                }
                name="Payment Mode"
              />
            </div>

            <span className="error-label">
              {formErrors?.selectedPaymentMode || ""}
            </span>
          </div>

          {/* DUAL || CASH || ONLINE */}
          {formValues.selectedPaymentMode?.value === "dual" && (
            <>
              <div className="formInputBox">
                <label htmlFor="cashAmount" className="formInputLabel">
                  Cash amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  name="cashAmount"
                  ref={assignRef("cashAmount")}
                  className={`formInput ${
                    formErrors.cashAmount ? "formError" : ""
                  }`}
                  placeholder="Enter Cash Amount"
                  value={formValues.cashAmount}
                  onChange={onChangeInput}
                />

                <span className="error-label">
                  {formErrors?.cashAmount || ""}
                </span>
              </div>

              <div className="formInputBox">
                <label htmlFor="onlineAmount" className="formInputLabel">
                  Online amount <span className="required">*</span>
                </label>

                <input
                  type="number"
                  name="onlineAmount"
                  ref={assignRef("onlineAmount")}
                  className={`formInput ${
                    formErrors.onlineAmount ? "formError" : ""
                  }`}
                  placeholder="Enter Online Amount"
                  value={formValues.onlineAmount}
                  onChange={onChangeInput}
                />

                <span className="error-label">
                  {formErrors?.onlineAmount || ""}
                </span>
              </div>
            </>
          )}
          {/* -------------- DUAL || CASH || ONLINE -------------- */}

          {/* PARTIAL || INSTALLMETN */}
          {formValues.selectedPaymentMode?.value === "partial" &&
          (formValues.selectedPlanType?.value === "addon_pt" ||
            formValues.selectedPlan?.info?.is_partial) ? (
            <>
              <div className="formInputBox">
                <label
                  htmlFor="selectedFirstPartialPaymentMode"
                  className="formInputLabel"
                >
                  First Installment Payment mode{" "}
                  <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedFirstPartialPaymentMode
                      ? "formError"
                      : ""
                  }`}
                  ref={assignRef("selectedFirstPartialPaymentMode")}
                >
                  <SelectDropdown
                    options={partialPaymentModes}
                    selectedOption={formValues.selectedFirstPartialPaymentMode}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(
                        selectedValue,
                        "selectedFirstPartialPaymentMode"
                      )
                    }
                    name="Payment Mode"
                  />
                </div>

                <span className="error-label">
                  {formErrors?.selectedFirstPartialPaymentMode || ""}
                </span>
              </div>

              <div className="wFull span4">
                <div className="partial-installments-container">
                  <div className="formInputBox">
                    <label htmlFor="firInsAmount" className="formInputLabel">
                      Enter Amount (Installment 1)
                      <span className="required">*</span>
                    </label>

                    <input
                      type="number"
                      name="firInsAmount"
                      ref={assignRef("firInsAmount")}
                      className={`formInput ${
                        formErrors.firInsAmount ? "formError" : ""
                      }`}
                      placeholder="Enter Amount"
                      value={installments.firInsAmount}
                      onChange={onChangeInput}
                      // disabled={formValues.selectedPlanType?.value === "regular"}
                    />

                    <span className="error-label">
                      {formErrors?.firInsAmount || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="firInsDate" className="formInputLabel">
                      Due Date (Installment 1){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="date"
                      name="firInsDate"
                      ref={assignRef("firInsDate")}
                      className={`formInput ${
                        formErrors.firInsDate ? "formError" : ""
                      } ${installments.firInsDate ? "date-has-value" : ""}`}
                      value={installments.firInsDate}
                      onChange={onChangeInput}
                      min={currentMonthCurrentDate}
                      // disabled={formValues.selectedPlanType?.value === "regular"}
                    />

                    <span className="error-label">
                      {formErrors?.firInsDate || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="secInsAmount" className="formInputLabel">
                      Enter Amount (Installment 2){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="number"
                      name="secInsAmount"
                      ref={assignRef("secInsAmount")}
                      className={`formInput ${
                        formErrors.secInsAmount ? "formError" : ""
                      }`}
                      placeholder="Enter Amount"
                      value={installments.secInsAmount}
                      onChange={onChangeInput}
                      // disabled={formValues.selectedPlanType?.value === "regular"}
                    />

                    <span className="error-label">
                      {formErrors?.secInsAmount || ""}
                    </span>
                  </div>

                  <div className="formInputBox">
                    <label htmlFor="secInsDate" className="formInputLabel">
                      Due Date (Installment 2){" "}
                      <span className="required">*</span>
                    </label>

                    <input
                      type="date"
                      name="secInsDate"
                      ref={assignRef("secInsDate")}
                      className={`formInput ${
                        formErrors.secInsDate ? "formError" : ""
                      } ${installments.secInsDate ? "date-has-value" : ""}`}
                      value={installments.secInsDate}
                      onChange={onChangeInput}
                      min={currentMonthCurrentDate}
                      // disabled={formValues.selectedPlanType?.value === "regular"}
                    />

                    <span className="error-label">
                      {formErrors?.secInsDate || ""}
                    </span>
                  </div>

                  {/* 3rd installment removed — partial payment now supports max 2 installments */}
                </div>
              </div>
            </>
          ) : null}

          {/* -------------- PARTIAL || INSTALLMETN -------------- */}
        </div>
      </form>
    </div>
  );
};

export default DPForm;
